module.exports = "<p>\n  event-statistics works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-statistics/event-statistics.component.html
// module id = ./src/app/routes/event/event-statistics/event-statistics.component.html
// module chunks = 9